import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './backend/layouts/Navbar';
import Sidebar from './backend/layouts/Sidebar';

const AdminLayout = () => {
  useEffect(() => {
    // Function to add a stylesheet to the head
    const addStylesheet = (href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    };

    // Function to add a script to the body bottom
    const addScript = (src, isAsync = true, callback = null) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = isAsync;
      if (callback) {
        script.onload = callback;
      }
      document.body.appendChild(script);
    };

    // Adding stylesheets
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/bootstrap.min.css`);
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/app.min.css`);

   
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/style.css`);
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/components.css`);
    addStylesheet(`${process.env.PUBLIC_URL}/admin_assets/css/custom.css`);

    // Load jQuery first
    addScript('https://code.jquery.com/jquery-3.6.0.min.js', false, () => {
      // Load Bootstrap and other scripts after jQuery is fully loaded
      addScript(`${process.env.PUBLIC_URL}/admin_assets/js/bootstrap.min.js`);
      addScript(`${process.env.PUBLIC_URL}/admin_assets/js/app.min.js`);

      addScript(`${process.env.PUBLIC_URL}/admin_assets/js/scripts.js`);
      addScript(`${process.env.PUBLIC_URL}/admin_assets/js/custom.js`);
      addScript(`${process.env.PUBLIC_URL}/admin_assets/bundles/apexcharts/apexcharts.min.js`);
    });

    // Cleanup function to remove the added stylesheets and scripts on component unmount
  }, []);

  return (
    <div>
      <Navbar />
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default AdminLayout;
